import { IncidentType } from "../types";

export const geojsonFileMessage =
  "Geojson featureCollection of all incidents of this type detected on this day.";
const gdacsArea =
  "Calculated as the maximum incident area which overlaps with our project boundary. Not the total area of the incident itself. The data will depend on the calculation method of the reporting body (for example 'Affected' area vs 'Global' area relating to boundaries of the incident's immediate local area of impact vs general wider possible impact consequence zone) and is referenced within the properties of each incident feature.";

export const areaTooltipMessages: Record<IncidentType, string> = {
  FIRE: "Maximum potential fire area detected. NOAA-21 data gives us scan/track properties to build the swath area with. We have calculated the maximum potentially effected area detected by VIIRS which has a 375m coverage, using the hypotenuse, max half diagonal from the centroid point, and using the longest possible radius from center to ensure we don't miss any potential area that could have resulted in the detection.",
  DEFORESTATION:
    "The area covered by the deforestation events which overlap with our project boundary have been calculated by GFW directly. The data is derived from 10-30m imagery (landsat 30, sentinel-2 10, radar RADD ~10)",
  FLOOD: gdacsArea,
  "TROPICAL CYCLONE": gdacsArea,
  EARTHQUAKE: gdacsArea,
  TSUNAMI: gdacsArea,
  VOLCANO: gdacsArea,
  DROUGHT: gdacsArea,
};

const gdacsInfo =
  "This data is retrieved from GDACS, using multiple different data sources and satellite data from various countries in an inter-agency agreement contributing to the GPM (Global Precipitation Mission), as well as Japan's shizuku.";

export const typeTooltipMessages: Record<IncidentType, string> = {
  FIRE: "This data is retrieved from FIRMS, using high confidence data from VIIRS NRT NOAA-21. Since it is Near Real Time data this is not yet processed as fully as standardised data. Intended for quick response and best available interpretation on the day of recording.",
  DEFORESTATION:
    "This data is retrieved from GFW 'Integrated Deforestation Alerts' which are alert based monitoring incidents aggregated together (from data which often overlaps/fragments/merges). Uses high confidence data from GLAD-L (Landsat-7&8), GLAD-S2 (Sentinel-2a&2b) and RADD (Sentinel-1).",
  FLOOD: gdacsInfo,
  "TROPICAL CYCLONE": gdacsInfo,
  EARTHQUAKE: gdacsInfo,
  TSUNAMI: gdacsInfo,
  VOLCANO: gdacsInfo,
  DROUGHT: gdacsInfo,
};

export const gdacsDetectionTime =
  "GDACS incident data relies on external sources and will be differently calculated for different datasets, but this time represents the most recent confirmed detection of this event.";
export const detectionTimeTooltipMessages: Record<IncidentType, string> = {
  FIRE: "Time that first incident was detected via VIIRS NOAA-21 as the satellite passed over. Incident by incident detection data can be found within the shape data.",
  DEFORESTATION:
    "GFW alerts provide aggregated data so the time is usually midnight though it represents simply the exact start of day that the data is confirmed to belong to. The day it belongs to is corroborated during post analysis to take into account issues such as clouds covering certain days detection and this date is subject to update",
  FLOOD: gdacsDetectionTime,
  "TROPICAL CYCLONE": gdacsDetectionTime,
  EARTHQUAKE: gdacsDetectionTime,
  TSUNAMI: gdacsDetectionTime,
  VOLCANO: gdacsDetectionTime,
  DROUGHT: gdacsDetectionTime,
};
